import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

export default {
    name: 'type_tax',
    state: {
        type_tax_List: [],
        acctype_tax_List: []
    },
    getters: {
        getType_tax: state => {
            return state.type_tax_List
        },
        getACCType_tax: state => {
            return state.acctype_tax_List
        },
    },
    mutations: {
        ADD_TYPE_TAX: (state, payload) => {
            state.type_tax_List = payload
        },
        ADD_ACCTYPE_TAX: (state, payload) => {
            state.acctype_tax_List = payload
        }
    },
    actions: {
        Fetch_TYPE_TAX(store) {
            return axios({
                method: "get",
                url: "./json/type_tax.json"
            }).then(response => {
                store.commit('ADD_TYPE_TAX', response.data);
            }).catch(err => {
                return err
            });
        },
        Fetch_ACCTYPE_TAX(store) {
            return axios({
                method: "get",
                url: "./json/acc_type_tax.json"
            }).then(response => {
                store.commit('ADD_ACCTYPE_TAX', response.data.type1);
            }).catch(err => {
                return err
            });
        },
        // FetchTYPETAXDB(store, { auth, params }) {
        //     return new Promise((resolve, reject) => {
        //         axios({
        //             method: "get",
        //             url: process.env.VUE_APP_SERVICEURL + "type_tax",
        //             auth: {
        //                 username: auth.username,
        //                 password: auth.password,
        //             },
        //             headers: {
        //                 "X-API-KEY": auth.apikey,
        //             },
        //         })
        //             .then((response) => {
        //                 resolve(response.data.data);
        //             })
        //             .catch((err) => {
        //                 reject(err);
        //             });
        //     });
        // },
        // FetchEditTypeTax(store, { auth, params }) {
        //     return new Promise((resolve, reject) => {
        //         axios({
        //             method: "get",
        //             url: process.env.VUE_APP_SERVICEURL + "type_tax",
        //             auth: {
        //                 username: auth.username,
        //                 password: auth.password,
        //             },
        //             params: {
        //                 id_type_tax: params,
        //                 tlc: auth.username
        //             },
        //             headers: {
        //                 "X-API-KEY": auth.apikey,
        //             },
        //         })
        //             .then((response) => {
        //                 resolve(response.data.data);
        //             })
        //             .catch((err) => {
        //                 reject(err);
        //             });
        //     });
        // },
        // FetchDataInput(store, { auth }) {
        //     return new Promise((resolve, reject) => {
        //         axios({
        //             method: "get",
        //             url: process.env.VUE_APP_SERVICEURL + "type_tax/data_input",
        //             auth: {
        //                 username: auth.username,
        //                 password: auth.password,
        //             },
        //             headers: {
        //                 "X-API-KEY": auth.apikey,
        //             },
        //         })
        //             .then((response) => {
        //                 resolve(response.data);
        //             })
        //             .catch((err) => {
        //                 reject(err);
        //             });
        //     });
        // },
        // PostTypetax(store, { auth, payload }) {
        //     return new Promise((resolve, reject) => {
        //         axios({
        //             method: "post",
        //             url: process.env.VUE_APP_SERVICEURL + 'type_tax',
        //             data: payload,
        //             auth: {
        //                 username: auth.username,
        //                 password: auth.password,
        //             },
        //             headers: {
        //                 "X-API-KEY": auth.apikey,
        //                 "Content-Type": 'application/json',
        //             },
        //         })
        //             .then(({ data, status }) => {
        //                 resolve(data);
        //             })
        //             .catch((err) => {
        //                 reject(err);
        //             });
        //     });
        // },
        // PutTypetax(store, { auth, payload }) {
        //     return new Promise((resolve, reject) => {
        //         axios({
        //             method: "put",
        //             url: process.env.VUE_APP_SERVICEURL + 'type_tax',
        //             data: payload,
        //             auth: {
        //                 username: auth.username,
        //                 password: auth.password,
        //             },
        //             headers: {
        //                 "X-API-KEY": auth.apikey,
        //                 "Content-Type": 'application/json',
        //             },
        //         })
        //             .then(({ data, status }) => {
        //                 resolve(data);
        //             })
        //             .catch((err) => {
        //                 reject(err);
        //             });
        //     });
        // },
    }
}